export default {"src":"/_next/static/media/hu.16c6335f.svg","height":480,"width":640,"blurWidth":0,"blurHeight":0};